import { supabase } from "./supabase";

const CMS_CHANGED_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/cms-changed`;

export type CmsTable =
  | "pages"
  | "services"
  | "plans"
  | "portfolio_items"
  | "case_studies"
  | "blog_posts"
  | "blog_categories"
  | "faqs"
  | "media"
  | "stores_directory"
  | "leads"
  | "audit_log";

export type CmsOperation = "insert" | "update" | "delete";

export async function notifyCmsChanged(
  table: CmsTable,
  operation: CmsOperation,
  recordId?: string,
  accessToken?: string,
): Promise<void> {
  const token = accessToken ?? (await supabase.auth.getSession()).data.session?.access_token;

  if (!token) {
    throw new Error("No hay sesion activa para notificar el cambio CMS.");
  }

  const payload: Record<string, unknown> = {
    table,
    operation,
    timestamp: new Date().toISOString(),
  };

  if (recordId) {
    payload.record_id = recordId;
  }

  const response = await fetch(CMS_CHANGED_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`cms-changed webhook failed: ${response.status} ${text}`);
  }
}
